import { Operator, Operators } from '../../types'
import FilterActionIcon from './FilterActionIcon'

type ModalOperatorProps = {
  operators: Operators[]
  handleChange?: (operator: Operator) => void
}

export default function ModalOperator({
  operators,
  handleChange
}: ModalOperatorProps) {
  const renderOperator = (operator: Operators) => {
    if (operator?.operator === 'filteraction') {
      return <FilterActionIcon />
    }

    return operator.des
  }
  return (
    <div className='list'>
      {operators.map((item, i) => (
        <button
          type='button'
          key={i}
          onClick={() => handleChange?.(item.operator)}
        >
          {renderOperator(item)}
        </button>
      ))}
    </div>
  )
}
